module.exports = __webpack_public_path__ + "src/assets/img/title.a269e1f6.png";